import type { FormatOptionLabelMeta } from 'react-select'

import type { SelectOption } from 'Components/Select/Select.types'

/**
 * Renders newlines in option labels, e.g. to keep the IMEI and
 * serial number of a device on their own lines. The selected value
 * in the input stays on a single line.
 */
export const formatMultilineOptionLabel = (
  option: SelectOption,
  { context }: FormatOptionLabelMeta<SelectOption>,
) =>
  context === 'menu' ? (
    <span className="text-linebreak">{option.label}</span>
  ) : (
    option.label
  )
